import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import DashHeader from "./header";
import { Dashboard } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import KPIDash from "./KPI";
import LeadFunnelChart from "./Charts/LeadFunnelChart";
import RevenueOverTime from "./Charts/RevenueOverTime";
import ProjectStatusPie from "./Charts/ProjectStatusPie";
import EnergySavings from "./Charts/EnergySaving";
import DashboardTables from "./dashboardTables";
// import GeoMapView from "./geoMapView";

const MainDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [leads, setLeads] = useState<any>([]);
  const [totalLeads, setTotalLeads] = useState<number>(0);
  const [activeCustomers, setActiveCustomers] = useState<number>(0);
  const [installedProjects, setInstalledProjects] = useState<number>(0);
  const [pendingInvoices, setPendingInvoices] = useState<number>(0);
  const [paidRevenue, setPaidRevenue] = useState<number>(0);
  const [quotesSent, setQuotesSent] = useState<number>(0);
  const [siteVisits, setSiteVisits] = useState<number>(0);

  const fetchDashKpis = async () => {
    try {
      const response: any[] = await callAPI("leads", Method.GET);
      setLeads(response);
      setTotalLeads(response.filter((item:any)=>item.leadType===0).length);

      // filter & count based on status key
      setActiveCustomers(
        response.filter((l) => l.status?.toLowerCase() === "prospect").length
      );
      setInstalledProjects(
        response.filter((l) => l.status?.toLowerCase() === "installed").length
      );
      setPendingInvoices(
        response.filter((l) => l.status?.toLowerCase() === "pending").length
      );
      setPaidRevenue(
        response.filter((l) => l.status?.toLowerCase() === "paid").length
      );
      setQuotesSent(
        response.filter((l) => l.status?.toLowerCase() === "sent").length
      );
      setSiteVisits(
        response.filter((l) => l.status?.toLowerCase().includes("won")).length
      ); // partial match
    } catch (error) {
      console.error("failed to retrieve data", error);
    }
  };

  useEffect(() => {
   fetchDashKpis().finally(() => setIsLoading(false));
  }, []);

  const leadFunnels = [
    { stage: "New", count: 100 },
    { stage: "Quoted", count: 80 },
    { stage: "Approved", count: 60 },
    { stage: "Installed", count: 40 },
    { stage: "Paid", count: 20 }
  ];

  const revenue = [
    { month: "Jan", billing: 15000, collection: 13000 },
    { month: "Feb", billing: 18000, collection: 17000 },
    { month: "Mar", billing: 22000, collection: 21000 }
  ];

  const projectStatus = [
    { status: "Not Started", count: 10 },
    { status: "In Progress", count: 25 },
    { status: "Completed", count: 15 }
  ];

  const installations = [
    {
      name: "Trivandrum Solar",
      lat: 8.5241,
      lng: 76.9366,
      status: "Installed"
    },
    { name: "Kozhikode Site", lat: 11.2588, lng: 75.7804, status: "Pending" }
  ];

  return (
    <Box p={2}>
      <DashHeader title="Dashboard Overview" icon={<Dashboard />} />

      <KPIDash
        totalLeads={totalLeads}
        activeCustomers={activeCustomers}
        installedProjects={installedProjects}
        pendingInvoices={pendingInvoices}
        paidRevenue={paidRevenue}
        quotesSent={quotesSent}
        siteVisits={siteVisits}
        isLoading={isLoading}
      />

      {/* Charts Section */}
      <Grid container spacing={3} mt={1}>
        {/* Energy + Project Status */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="subtitle1" sx={{fontSize:'1rem'}} fontWeight={600} mb={1}>
              Energy Savings Analytics
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <EnergySavings goal={20} saved={10} />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="subtitle1" fontWeight={600} mb={1}>
              Project Progress Status
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <ProjectStatusPie data={projectStatus} />
          </Paper>
        </Grid>

        {/* Lead Funnel */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="subtitle1" fontWeight={600} mb={1}>
              Lead Funnel
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <LeadFunnelChart data={leadFunnels} />
          </Paper>
        </Grid>

        {/* Revenue Graph */}
        <Grid item xs={12} md={6}>
          <Paper elevation={3} sx={{ p: 2, borderRadius: 3 }}>
            <Typography variant="subtitle1" fontWeight={600} mb={1}>
              Revenue Over Time
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <RevenueOverTime data={revenue} />
          </Paper>
        </Grid>

        {/* <GeoMapView installations={installations}/> */}
        <DashboardTables leads={leads}/>
      </Grid>
    </Box>
  );
};

export default MainDashboard;
